const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoExtOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Border_box",
    "data-name": "Border box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    style: {
      fill: "none",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_compound",
    "data-name": "Layer 1 compound"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow_up",
    "data-name": "Arrow up"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,0h-7c-.55,0-1,.45-1,1v.5c0,.55.45,1,1,1h3.64L7.16,14.98c-.39.39-.39,1.02,0,1.41l.35.35c.39.39,1.02.39,1.41,0l12.57-12.57v3.83c0,.55.45,1,1,1h.5c.55,0,1-.45,1-1V1c0-.55-.45-1-1-1Z",
    style: {
      fill: "currentColor",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3,12.36h-.5c-.55,0-1,.45-1,1v7.49H3.2V3.12h7.5c.55,0,1-.45,1-1v-.5c0-.55-.45-1-1-1H2.7C1.6.62.7,1.51.7,2.62v18.73c0,1.1.9,2,2,2h18.1s.5,0,.5,0c1.1,0,2-.9,2-2v-8c0-.55-.45-1-1-1Z",
    style: {
      fill: "currentColor",
      strokeWidth: 0
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoExtOpen);
export default __webpack_public_path__ + "static/media/video-ext-open.c46461dbeef07fe2e59ab1420f932794.svg";
export { ForwardRef as ReactComponent };